var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-switcher" },
    [
      _c("v-select", {
        staticClass: "select_lang",
        attrs: { items: _vm.availableLanguages, label: "" },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.selectLocale(_vm.lang)
          },
          change: function($event) {
            return _vm.selectLocale(_vm.$i18n.locale)
          }
        },
        model: {
          value: _vm.$i18n.locale,
          callback: function($$v) {
            _vm.$set(_vm.$i18n, "locale", $$v)
          },
          expression: "$i18n.locale"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55622826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55622826","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/LanguageSwitcher.vue
// module id = null
// module chunks = 